
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 3.8672C2 1.73141 3.68675 0 5.76747 0H10.0417C12.1224 0 13.8091 1.73141 13.8091 3.8672V11.8991C13.8091 14.0349 12.1224 15.7663 10.0417 15.7663H5.76747C3.68675 15.7663 2 14.0349 2 11.8991V3.8672ZM5.76747 1.54688C4.51904 1.54688 3.50699 2.58573 3.50699 3.8672V11.8991C3.50699 13.1806 4.51904 14.2195 5.76747 14.2195H10.0417C11.2901 14.2195 12.3022 13.1806 12.3022 11.8991V3.8672C12.3022 2.58573 11.2901 1.54688 10.0417 1.54688H5.76747ZM15.6283 6.477C15.8583 6.12105 16.326 6.02392 16.6727 6.26006C17.471 6.80371 18 7.73694 18 8.79725V16.1329C18 18.2687 16.3132 20 14.2325 20H10.2888C9.40211 20 8.61304 19.5692 8.11028 18.9036C7.85531 18.566 7.91523 18.0801 8.24411 17.8184C8.573 17.5567 9.0463 17.6182 9.30129 17.9558C9.53088 18.2598 9.88766 18.4531 10.2888 18.4531H14.2325C15.481 18.4531 16.493 17.4143 16.493 16.1329V8.79725C16.493 8.27703 16.235 7.81831 15.8396 7.54909C15.4928 7.31295 15.3982 6.83296 15.6283 6.477Z","fill":"#8338EC"}})])
          )
        }
      }
    